module.exports = __webpack_public_path__ + "img/homepage-2.1800d711.webp";